/**
 * Returns merged objects as a sibgle object.
 * TS so far does not support this out of the box.
 */
import config from '@/config';

export function mergeObjects(...args) {
    let target = args[0];
    for (let i = 1; i < arguments.length; i++) {
        let source = arguments[i];
        for (let key in source) {
            if (source.hasOwnProperty(key)) {
                target[key] = source[key];
            }
        }
    }
    return target;
}

export function debounce(func, wait, immediate) {
    let timeout;
    return function () {
        let context = this, args = arguments;
        let later = function () {
            timeout = null;
            if (!immediate) func.apply(context, args);
        };
        let callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) func.apply(context, args);
    };
}

export function scroll(id, offset = 0, behavior = "smooth", target) {
    target = target || window;
    const el = document.getElementById(id);
    if (!el) return;
    if (target === window) {
        const top = el.getBoundingClientRect().top + window.scrollY + offset;
        window.scrollTo({
            top,
            behavior
        });
    } else {
        // todo
        const top = el.offsetTop + offset;
        console.log(el.getBoundingClientRect().top, target.offsetTop, offset)
        console.log("EL", top);

        target.scroll({
            top,
            behavior
        });
    }
}

export function crossDownload(url) {
    const req = new XMLHttpRequest();
    req.open("GET", url, true);
    req.responseType = "blob";

    // todo
    //let authToken = localStorage.getItem(config.STORAGE_AUTH_TOKEN);
    //req.setRequestHeader('Authorization', authToken);

    req.onload = function (event) {
        const blob = req.response;
        let fileName = req.getResponseHeader('Content-Disposition').split("filename=")[1];

        fileName = decodeURI(fileName.replace(/['"]/g, ''))
        const __fileName = fileName;
        const contentType = req.getResponseHeader("content-type");
        if (window.navigator.msSaveOrOpenBlob) {
            // Internet Explorer
            window.navigator.msSaveOrOpenBlob(new Blob([blob], {type: contentType}), fileName);
        } else {
            const link = document.createElement('a');
            document.body.appendChild(link);
            link.download = __fileName;
            link.href = window.URL.createObjectURL(blob);
            link.click();
            document.body.removeChild(link); //remove the link when done
        }
    };
    req.send();
};

export function isElementOverflowing(el) {
    if ( typeof el == "string" ) el = document.getElementById(el);
    if ( !el ) return false;

    const isVerticalOverflow = el.scrollHeight > el.clientHeight;
    const isHorizontalOverflow = el.scrollWidth > el.clientWidth;

    if (isVerticalOverflow || isHorizontalOverflow) {
        el.classList.add("--overflowing");
        //console.log("isElementOverflowing true", el);
        return true;
    } else {
        //console.log("isElementOverflowing false", el);
        el.classList.remove("--overflowing");
        return false;
    }
}

export function isLinkValid(str) {
    const pattern = new RegExp('^(https?:\\/\\/)?' + // protocol
        '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
        '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
        '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
        '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
        '(\\#[-a-z\\d_]*)?$', 'i'); // fragment locator
    return !!pattern.test(str);
};

export function isEmailValid(email) {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
}

export async function copy(text, html) {
    /*const Clipboard = (function(window, document, navigator) {
        var textArea,
            copy;

        function isOS() {
            return navigator.userAgent.match(/ipad|iphone/i);
        }

        function createTextArea(text) {
            textArea = document.createElement('textArea');
            textArea.value = text;
            document.body.appendChild(textArea);
        }

        function selectText() {
            var range,
                selection;

            if (isOS()) {
                range = document.createRange();
                range.selectNodeContents(textArea);
                selection = window.getSelection();
                selection.removeAllRanges();
                selection.addRange(range);
                textArea.setSelectionRange(0, 999999);
            } else {
                textArea.select();
            }
        }

        function copyToClipboard() {
            document.execCommand('copy');
            document.body.removeChild(textArea);
        }

        copy = function(text) {
            createTextArea(text);
            selectText();
            copyToClipboard();
        };

        return {
            copy: copy
        };
    })(window, document, navigator);
    return Clipboard.copy(text);*/

    if ( isIOS() ) {
        const el = document.createElement(html ? 'div' : 'textarea');
        const selected =
            document.getSelection().rangeCount > 0
                ? document.getSelection().getRangeAt(0)
                : false;
        el.style.position = 'absolute';
        el.style.left = '-9999px';
        if (html) {
            el.contentEditable = 'true';
            el.innerHTML = html;
            document.body.appendChild(el);
            const range = document.createRange();
            range.selectNodeContents(el);
            const selection = document.getSelection();
            selection.removeAllRanges();
            selection.addRange(range);
        } else {
            el.value = text;
            //el.setAttribute('readonly', '');
            document.body.appendChild(el);
            el.select();
        }
        document.execCommand('copy');
        document.body.removeChild(el);
        if (selected) {
            document.getSelection().removeAllRanges();
            document.getSelection().addRange(selected);
        }
    }
    else {
        try {
            if (html && navigator?.clipboard?.write && typeof ClipboardItem !== 'undefined') {
                const item = new ClipboardItem({
                    'text/plain': new Blob([text], {type: 'text/plain'}),
                    'text/html': new Blob([html], {type: 'text/html'}),
                });
                await navigator.clipboard.write([item]);
                console.log('HTML copied to clipboard:', html);
            } else if (navigator?.clipboard?.writeText) {
                await navigator.clipboard.writeText(text);
                console.log('Text copied to clipboard:', text);
            } else {
                console.warn('Clipboard API not available or writeText not supported.');
                // Fallback for older browsers if needed
                //fallbackCopyToClipboard(textToCopy);
            }
        } catch (err) {
            console.error('Failed to copy text:', err);
        }
    }
}

export function isIOS() {
    const iOSMobile = [
            'iPad Simulator',
            'iPhone Simulator',
            'iPod Simulator',
            'iPad',
            'iPhone',
            'iPod'
        ].includes(navigator.platform)
        // iPad on iOS 13 detection
        || (navigator.userAgent.includes("Mac") && "ontouchend" in document);
    //console.log("IsIos iOSMobile ", iOSMobile);
    return iOSMobile;
}

export function isMacOrIOs() {
    return /(Mac|iPhone|iPod|iPad)/i.test(navigator.platform) || isIOS();
}

export function onlyUnique(value, index, self) {
    return self.indexOf(value) === index;
}

export function flatArray(items, prop="children") {
    if (!items) return null;
    const result = [];
    const walk = (list) => {
        for (const item of list) {
            result.push(item);
            if (item[prop]) walk(item[prop]);
        }
    };
    walk(items);
    return result;
}

export function parentsOf(item, prop="parent") {
    if (!item?.parent) return null;
    let parents = [item.parent];
    if ( item.parent.parent ) parents = parents.concat(parentsOf(item.parent, prop));
    return parents;
}

export function intersection(array1, array2) {
    if ( !array1?.length || !array2?.length ) return null;
    return [...new Set(array1)].filter(item => array2.includes(item));
}